import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { getCurrentUserData } from "../services/settingsService/settingsService";
import { useAuth } from "./AuthContext";

import { logger } from "utils/logger";
type User = {
  firstName: string;
  lastName: string;
  email: string;
} | null;

interface UserContextValue {
  user: User;
  setUser: (user: User) => void;
  reloadUser: () => Promise<void>;
}

const UserContext = createContext<UserContextValue | null>(null);

export const UserProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const [user, setUser] = useState<User>(null);

  const reloadUser = useCallback(async () => {
    try {
      const data = await getCurrentUserData();
      setUser({
        firstName: data.first_name || "Name",
        lastName: data.last_name || "Lastname",
        email: data.email || "",
      });
    } catch (error) {
      logger.error("Ошибка загрузки данных пользователя:", error);
      setUser(null);
    }
  }, []);

  useEffect(() => {
    if (!isAuthenticated) {
      setUser(null);
      return;
    }

    void reloadUser();
  }, [isAuthenticated, reloadUser]);

  return (
    <UserContext.Provider value={{ user, setUser, reloadUser }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => {
  const ctx = useContext(UserContext);
  if (!ctx) throw new Error("useUser must be used within UserProvider");
  return ctx;
};
